// Regras de documento da casa usadas pelo editor (Guia de Formatacao e
// Manual de Identidade Visual). Mantidas num lugar so para o editor, o painel
// de estilos e os conversores usarem os mesmos valores.

// Citacao (estilo Quote): Segoe UI 11 pt, italico, recuo esquerdo de 3 cm,
// entrelinha simples.
export const QUOTE_STYLE = "margin: 12px 0 12px 3cm; padding: 0; border: none; background: none; font-style: italic; font-size: 11pt; line-height: 1.15; color: #111827;";

// Nota de rodape, como no Word: regua curta a esquerda e as notas em 10 pt,
// justificadas, com o numero sobrescrito. Estilo em linha porque a area de
// notas vai junto no HTML salvo (portal, e-mail e PDF).
export const FOOTNOTE_AREA_STYLE = "margin: 18pt 0 0 0; padding: 0;";
export const FOOTNOTE_RULE_STYLE = "width: 5cm; margin: 0 auto 4pt 0; border: 0; border-top: 1px solid #111827;";
export const FOOTNOTE_ITEM_STYLE = "margin: 0 0 2pt 0; font-size: 10pt; line-height: 1.15; text-align: justify; text-indent: 0;";

// As cinco cores do Manual de Identidade Visual: as unicas permitidas em
// documento (paleta fechada).
export const BRAND_COLORS = [
    { name: "Roxo Profundo", bg: "#150030", fg: "#ffffff" },
    { name: "Roxo Equipe", bg: "#7857a8", fg: "#ffffff" },
    { name: "Lilás Inclusivo", bg: "#7877df", fg: "#ffffff" },
    { name: "Azul Ágil", bg: "#d3f8f1", fg: "#150030" },
    { name: "Off-white", bg: "#f1ede4", fg: "#150030" },
];

// Fontes oferecidas. Segoe UI e a do guia; nos PDFs ela sai em Selawik
// (substituta metrica livre), e no editor tambem, quando o computador nao
// tem Segoe UI.
export const FONT_FAMILIES = [
    { text: "Segoe UI (padrão)", value: null },
    { text: "Times New Roman", value: "\"Times New Roman\", Times, serif" },
    { text: "Arial", value: "Arial, Helvetica, sans-serif" },
];

export const FONT_SIZES = ["8pt", "9pt", "10pt", "11pt", "12pt", "14pt", "16pt", "18pt", "21pt", "24pt", "28pt", "36pt"];
export const DEFAULT_FONT_SIZE = "11pt";

export const LINE_HEIGHTS = [
    { text: "Simples (1,0)", value: "1" },
    { text: "1,15 (padrão)", value: null },
    { text: "1,5", value: "1.5" },
    { text: "Duplo (2,0)", value: "2" },
];

// Folha A4 e margens de visualizacao (cm). "Padrão BeJ" = margens do PDF.
export const PAGE = { widthCm: 21, heightCm: 29.7 };
export const PAGE_SIZES = { portrait: PAGE, landscape: { widthCm: 29.7, heightCm: 21 } };
// Rodape das paginas internas dos relatorios (o "timbrado" do RVC): texto a
// 7 pt, 32 pt das bordas, 6 pt abaixo do inicio da margem inferior.
export const PAGE_FOOTER = { label: "Brizola e Japur Administração Judicial", sideCm: 1.13, offsetCm: 0.21, fontPt: 7 };
export const MARGIN_PRESETS = [
    { key: "bej", text: "Padrão BeJ", top: 2, bottom: 2, left: 1.5, right: 1.5 },
    { key: "normal", text: "Normal", top: 2.5, bottom: 2.5, left: 3, right: 3 },
    { key: "narrow", text: "Estreita", top: 1.27, bottom: 1.27, left: 1.27, right: 1.27 },
    { key: "abnt", text: "ABNT", top: 3, bottom: 2, left: 3, right: 2 },
];

export const CM_TO_PX = 37.795;
